import {PreviewDialogState} from '../states/preview-dialog.state';
import {createReducer, on} from '@ngrx/store';
import {BelegEntitiesActions} from '../actions/beleg-entities.actions';

export const initialPreviewDialogState: PreviewDialogState = {
  isOpen: false,
};

export const previewDialogReducer = createReducer(
  initialPreviewDialogState,

  on(BelegEntitiesActions.openBelegPreviewDialog, (state, {inhaberId, belegId}) => ({
    ...state,
    isOpen: true,
    inhaberId,
    belegId,
  })),

  on(BelegEntitiesActions.closePreviewDialog, () => ({
    ...initialPreviewDialogState,
  })),

  on(BelegEntitiesActions.closeBelegPreviewDialog, () => ({
    ...initialPreviewDialogState,
  })),
);
